import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Colorpicker from "@Shared/components/inputs/colorpicker";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import tinyColor from "tinycolor2";
import InlineLoader from "@Shared/components/general/inline-loader";
import MaterialInput from "@Shared/components/inputs/material-input";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { cloneDeep, debounce, isEmpty, omit } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentTagsTable",
  components: {
    Colorpicker,
    InlinePrompt,
    InlineLoader,
    MaterialInput,
    SimpleButton
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      columns: ["preview", "delete"],
      deleting: {},
      editing: {}
    };
  },
  computed: {
    isDataEmpty() {
      return isEmpty(this.data);
    },
    options() {
      return {
        filterable: false,
        showChildRowToggler: false,
        sortable: [],
        headings: {
          preview: this.$t("global.words.preview"),
          delete: this.$t("global.words.delete")
        },
        tabbable: false,
        columnsClasses: {
          preview: "hidden-heading",
          delete: "hidden-heading"
        },
        skin: "table table-hover",
        perPage: 99999
      };
    }
  },
  inactive() {
    this.editing = {};
  },
  methods: {
    getTextColor(color) {
      if (tinyColor(color).isDark() || tinyColor(color).getLuminance() < 0.5) return "#ffffff";
      return "#565656";
    },
    async handleRemove({
      id
    }) {
      this.$set(this.deleting, id, {
        loading: true
      });
      this.$emit("delete", id);
    },
    isDeleting({
      id
    }) {
      var _this$deleting$id$loa, _this$deleting$id;
      return (_this$deleting$id$loa = (_this$deleting$id = this.deleting[id]) == null ? void 0 : _this$deleting$id.loading) != null ? _this$deleting$id$loa : false;
    },
    isEditing({
      id
    }) {
      return !isEmpty(this.editing[id]);
    },
    preEditColourLabel: debounce(function (label) {
      this.$set(this.editing[label.id], "colour", label.colour), this.$nextTick(() => {
        this.preEditLabel(label);
      });
    }, 200),
    preEditLabel(label) {
      if (!label.name) return;
      this.$emit("preEdit", label);
    },
    showRowChild(label) {
      this.$set(this.editing, label.id, _objectSpread(_objectSpread({}, label), {}, {
        oldName: cloneDeep(label.name),
        oldColour: cloneDeep(label.colour),
        loading: false,
        loadingSucceeded: true
      }));
      this.toggleRowChild(label.id);
    },
    toggleRowChild(id) {
      this.$nextTick(() => {
        this.$refs.tagsTable.toggleChildRow(id);
      });
    },
    handleEdit(label) {
      const newLabel = cloneDeep(this.editing[label.id]);
      if (newLabel.name === newLabel.oldName && newLabel.colour === newLabel.oldColour) return this.closeChildRow(label.id);
      this.editing[label.id].loading = true;
      this.$emit("edit", _objectSpread(_objectSpread({}, label), omit(newLabel, ["oldName", "oldColour", "loading", "loadingSucceeded"])));
    },
    finishEditing({
      succeeded,
      id
    }) {
      if (succeeded) this.closeChildRow(id);else {
        this.editing[id].loadingSucceeded = false;
        this.editing[id].loading = false;
      }
    },
    restoreChanges({
      id
    }) {
      const label = cloneDeep(this.editing[id]);
      const labelRestored = _objectSpread(_objectSpread({}, omit(label, ["oldName", "oldColour", "loading", "loadingSucceeded"])), {}, {
        name: label.oldName,
        colour: label.oldColour
      });
      this.preEditLabel(labelRestored);
      this.closeChildRow(id);
    },
    closeChildRow(id) {
      this.toggleRowChild(id);
      this.$nextTick(() => {
        this.$delete(this.editing, id);
      });
    },
    isLoading({
      id
    }) {
      var _this$editing$id$load, _this$editing$id;
      return (_this$editing$id$load = (_this$editing$id = this.editing[id]) == null ? void 0 : _this$editing$id.loading) != null ? _this$editing$id$load : false;
    },
    isInvalid({
      id
    }) {
      var _this$editing$id$name, _this$editing$id2;
      return (_this$editing$id$name = !((_this$editing$id2 = this.editing[id]) != null && _this$editing$id2.name)) != null ? _this$editing$id$name : true;
    }
  }
});